import AlgoliaEvent from './AbstractEvent';

class PurchasedAfterSearch extends AlgoliaEvent {
  algoliaEvent = 'purchasedObjectIDsAfterSearch';

  customEventName = 'purchased_after_search';
}

export default PurchasedAfterSearch;
